import React from 'react';
import '../styles/AppFooter.css';
import { showIntercom } from '../intercom';

const TERMS_URL = 'https://www.orcanos.com/orcanos-terms-of-use';
const PRIVACY_URL = 'https://www.orcanos.com/privacy-policy';

// Shared legal/version footer shown on the login screen and the dashboard.
// Classes are prefixed `app-footer` to stay clear of the global stylesheet
// (Critical Note #15). `variant` tints it for the purple login background.
// Credits moved to the bottom of the left nav (AppNav `NavCredits`, 2026-10-27).
function AppFooter({ version, variant, account }) {
  return (
    <footer className={`app-footer${variant ? ` app-footer-${variant}` : ''}`}>
      <span className="app-footer-item">© Orcanos 2026</span>
      <span className="app-footer-sep">|</span>
      <span className="app-footer-item">Licensed to {account || 'your account'}</span>
      <span className="app-footer-sep">|</span>
      <span className="app-footer-item">Version: {version || '—'} Beta</span>
      <span className="app-footer-sep">|</span>
      <a className="app-footer-link" href={TERMS_URL} target="_blank" rel="noopener noreferrer">
        Terms of Use
      </a>
      <span className="app-footer-comma">,</span>
      <a className="app-footer-link" href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      <span className="app-footer-comma">,</span>
      <button type="button" className="app-footer-link app-footer-chat" onClick={showIntercom}>
        Let's Chat
      </button>
    </footer>
  );
}

export default AppFooter;
